<!--
角色管理
-->
<template>
	<div class="box-page" v-loading="loading">
		<div class="flex-c-s mb20">
			<div class="box-title">角色管理</div>
			<div class="box-btn" v-if="btns['add-role']" @click="openAdd">
				<img src="@/assets/images/btn_add_icon.png" width="12" height="12" />
				<span>新增角色</span>
			</div>
		</div>

		<div class="my-table">
			<el-table :data="list" width="100%">
				<el-table-column prop="roleName" label="角色名称" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="roleDescription" label="角色描述" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="操作" width="140">
					<template slot-scope="scope">
						<div class="row-btns" v-if="scope.row.roleType != '0'">
							<el-tooltip class="item" effect="dark" content="编辑" placement="top">
								<img src="@/assets/images/yggl_icon_bj.png" v-if="btns['update-role']"
								@click="openUpdate(scope.row.roleId)" />
							</el-tooltip>
							<el-tooltip class="item" effect="dark" content="删除" placement="top">
								<img src="@/assets/images/yggl_icon_sc.png" v-if="btns['del-role']"
								@click="openDel(scope.row.roleId)" />
							</el-tooltip>
						</div>
						<div v-else>暂无操作</div>
					</template>
				</el-table-column>
			</el-table>

			<el-pagination background layout="prev, pager, next" :total="total" :current-page.sync="page"
				class="box-paging" @current-change="getRoleList">
			</el-pagination>
		</div>

		<el-dialog :title="dialogType == '1' ? '新增角色' : '编辑角色'" :visible.sync="dialogVisible"
			:close-on-click-modal="false" v-el-drag-dialog @close="changeClose">
			<el-form :model="roleForm" :rules="roleRules" label-width="100px" ref="roleForm" v-loading="dialogLoading">
				<el-form-item label="角色名称:" prop="roleName">
					<el-input v-model="roleForm.roleName" placeholder="请输入角色名称"></el-input>
				</el-form-item>
				<el-form-item label="角色描述:" prop="roleDescription">
					<el-input v-model="roleForm.roleDescription" placeholder="请输入角色描述"></el-input>
				</el-form-item>
				<el-form-item label="选择权限:" prop="permsIds">
					<el-tree :data="routers" show-checkbox node-key="id" :props="defaultProps" ref="tree"
						@check="changeTree">
						<span slot-scope="{ data }">{{ data.meta.title }}</span>
					</el-tree>
				</el-form-item>
				<div class="flex-row-center">
					<div class="box-btn" style="width: 290px" @click="handleRole">
						确认{{ dialogType == '1' ? '新增' : '修改' }}
					</div>
				</div>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				list: [], // 角色列表
				page: 1,
				total: 1,
				loading: false,

				// 树状结构配置值
				defaultProps: {
					children: 'children',
					label: 'id'
				},

				dialogVisible: false,
				dialogType: '', // 1 新增 2 编辑
				dialogLoading: false,

				nowId: '', // 当前编辑角色id

				roleForm: {
					roleName: '', // 角色名称
					roleDescription: '', // 角色描述
					permsIds: [] // 选择权限集合
				},
				roleRules: {
					roleName: {
						required: true,
						message: '请输入角色名称',
						trigger: 'blur'
					},
					roleDescription: {
						required: true,
						message: '请输入角色描述',
						trigger: 'blur'
					},
					permsIds: {
						required: true,
						message: '请选择权限',
						trigger: 'change'
					}
				}
			}
		},
		computed: {
			routers() {
				return this.$store.state.app.routers
			},
			// 按钮权限
			btns() {
				return this.$route.meta.btns
			}
		},
		watch: {
			// 使用监听移出permsIds的change必填不及时问题
			'roleForm.permsIds'(v) {
				if (v.length > 0) {
					this.$refs.roleForm.clearValidate('permsIds')
				}
			}
		},
		mounted() {
			this.getRoleList()
		},
		methods: {
			// 获取角色列表
			getRoleList() {
				this.loading = true
				this.$api.organization
					.roleList({
						page: this.page,
						limit: 10,
						keyword: ''
					})
					.then(({
						data
					}) => {
						this.loading = false
						if (data.code == 200) {
							this.list = data.data
							this.total = data.total
						}
					})
					.catch(() => {
						this.loading = false
					})
			},

			// 新增角色
			openAdd() {
				this.dialogVisible = true
				this.dialogType = '1'
				this.$nextTick(() => {
					this.$refs.roleForm.clearValidate()
				})
			},

			// 确认新增
			handleAdd() {
				this.dialogLoading = true
				const permsList = JSON.stringify(this.getTreeList())
				const ids = this.roleForm.permsIds.map((item) => item.id) // 权限id集合

				this.$api.organization
					.addRole({
						...this.roleForm,
						permsIds: JSON.stringify(ids),
						permsList
					})
					.then(({
						data
					}) => {
						this.dialogLoading = false
						if (data.code == 200) {
							this.getRoleList()
							this.$notify.success({
								title: '提示',
								message: '新增成功'
							})
							this.dialogVisible = false
						}
					})
					.catch(() => {
						this.dialogLoading = false
					})
			},

			// 编辑角色
			openUpdate(id) {
				this.dialogVisible = true
				this.dialogType = '2'
				this.nowId = id

				this.$nextTick(() => {
					this.$refs.roleForm.clearValidate()
					this.dialogLoading = true

					// 获取角色详情
					this.$api.organization
						.detailRole(id)
						.then(({
							data
						}) => {
							this.dialogLoading = false
							if (data.code == 200) {
								this.roleForm = data.data
								// 设置已勾选
								const ids = JSON.parse(this.roleForm.permsIds)
								ids.forEach((item) => {
									this.$refs.tree.setChecked(item, true)
								})
							}
						})
						.catch(() => {
							this.dialogLoading = false
						})
				})
			},

			// 确认编辑
			handleUpdate() {
				this.dialogLoading = true
				// 如果所选权限id集合为字符串，则未修改权限，需要手动调用一次获取当前的权限
				if (typeof this.roleForm.permsIds == 'string') {
					this.changeTree()
				}
				const permsList = JSON.stringify(this.getTreeList())
				const ids = this.roleForm.permsIds.map((item) => item.id) // 权限id集合

				this.$api.organization
					.updateRole({
						...this.roleForm,
						roleId: this.nowId,
						permsIds: JSON.stringify(ids),
						permsList
					})
					.then(({
						data
					}) => {
						this.dialogLoading = false
						if (data.code == 200) {
							this.getRoleList()
							this.$notify.success({
								title: '提示',
								message: '修改成功'
							})
							this.dialogVisible = false
						}
					})
					.catch(() => {
						this.dialogLoading = false
					})
			},

			// 表单操作验证
			handleRole() {
				this.$refs.roleForm.validate((valid) => {
					if (valid) {
						this.dialogType === '1' ? this.handleAdd() : this.handleUpdate()
					} else return false
				})
			},

			// 删除角色
			openDel(id) {
				this.$confirm('此操作将删除该角色信息, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						this.loading = true
						this.$api.organization
							.delRole(id)
							.then(({
								data
							}) => {
								this.loading = false
								if (data.code == 200) {
									if (this.total % 10 == 1 && this.page != 1) this
										.page-- // 若当前删除的为当前页最后一个 则page-1
									this.getRoleList()
									this.$notify.success({
										title: '提示',
										message: '删除成功'
									})
								}
							})
							.catch(() => {
								this.loading = false
							})
					})
					.catch(() => {})
			},

			changeClose() {
				this.$refs.roleForm.resetFields()
				this.$refs.tree.setCheckedKeys([])
			},

			// 权限节点选中状态变化事件
			changeTree() {
				// 获取当前选中所有
				const checkId = this.$refs.tree.getCheckedKeys()
				// 是否选中操作工单权限 选中默认勾选工单详情权限，没有反之
				if (checkId.indexOf('37') > -1) {
					this.$refs.tree.setChecked('11', true)
				} else {
					this.$refs.tree.setChecked('11', false)
				}

				this.roleForm.permsIds = this.$refs.tree.getCheckedNodes(false, true)
			},

			getTreeList() {
				var menu = []
				this.roleForm.permsIds.forEach((item) => {
					if (item.pid === '-1') {
						// 先遍历获取一级路由菜单
						menu.push({
							...item,
							children: [] // 获取的选中的children带有下级，累赘不要
						})
					} else {
						this.getTreeChildren(menu, item) // 不是一级
					}
				})

				return menu
			},

			getTreeChildren(list = [], data) {
				// 主要使用了浅拷贝原理 递归修改时保证menu会修改
				var isPush = false // 是否找到对应上级
				var tmep = [] // 获取当前list遍历的item所有children集合

				list.forEach((item) => {
					if (item.children && item.children.length > 0) {
						// 存在子级则统一保存
						tmep = tmep.concat(item.children)
					}
					// 找到了父级
					if (item.id === data.pid) {
						isPush = true
						const obj = {
							...data,
							children: []
						}
						if (data.type === 'button') {
							// 按钮权限放入父级的meta中，注册为路由元信息
							const btns = item.meta.btns || {} // 事先没有在meta中设置btns这个键 做一个默认值
							item.meta.btns = {
								...btns,
								[data.name]: true // 以按钮名为键
							}
						} else {
							// 菜单路由权限则直接放入父级children中
							item.children.push(obj)
						}
					}
				})

				// 这是没有找到父级且当前list遍历后有item存在子级 递归，继续寻找
				if (tmep.length > 0 && !isPush) {
					this.getTreeChildren(tmep, data)
				}
			}
		}
	}
</script>
<style lang="scss" scoped></style>
